import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { DualColumnDropdown, Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { PrescriptionValueUtils } from '@grandvisionhq/utils';
import { PLACEHOLDER } from '../../../../constants.js';
import { CLSelectLabel } from '../CLSelectLabel/CLSelectLabel.js';
import { getEyeLabel, getAttributeLabel } from '../utils.js';

// @ts-ignore
const sortOptions = (keyA, keyB)=>keyA - keyB
;
const CLPrescriptionSelect = /*#__PURE__*/ React.memo(({ name , eyeSideId , options , selectedValue , selectClassName , onChange , isDisabled , hasError  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const intl = useIntl();
    const optionsValues = Object.values(options);
    const selectId = `${eyeSideId}-${name}-select`;
    const selectName = `prescription-${name}`;
    const eyeLabel = eyeSideId !== 'both' ? getEyeLabel(intl, eyeSideId) : undefined;
    const attributeLabel = getAttributeLabel(intl, name);
    const label = [
        attributeLabel,
        eyeLabel
    ].filter(Boolean).join(' ');
    const selectedFormValue = selectedValue ? {
        name,
        value: selectedValue
    } : undefined;
    const formattedValue = PrescriptionValueUtils.formatPrescriptionValue(name, Number(selectedValue));
    const handleChange = React.useCallback((value)=>{
        onChange(name, String(value));
    }, []);
    if (optionsValues.length === 1) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLSelectLabel, {
            name: name,
            htmlFor: selectId
        }), /*#__PURE__*/ React.createElement("div", {
            className: classnames('cl-prescription-select cl-prescription-select__single-value', {
                'cl-prescription-select__single-value--disabled': isDisabled
            }),
            "aria-label": `${label} ${optionsValues[0]}`,
            "data-t": selectName
        }, optionsValues[0]));
    }
    if (name === 'power' && !isMobile) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLSelectLabel, {
            name: name,
            htmlFor: selectId
        }), /*#__PURE__*/ React.createElement(DualColumnDropdown, {
            label: label,
            className: classnames('cl-prescription-select', selectClassName),
            options: options,
            selectedValue: formattedValue,
            onChange: handleChange,
            isDisabled: isDisabled,
            isInvalid: hasError
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLSelectLabel, {
        name: name,
        htmlFor: selectId
    }), /*#__PURE__*/ React.createElement(Select, {
        id: selectId,
        "aria-label": label,
        "aria-invalid": hasError,
        className: classnames('cl-prescription-select', selectClassName),
        initialState: selectedFormValue,
        disabled: isDisabled,
        options: options,
        sortOptionsBy: sortOptions,
        onChange: handleChange,
        name: selectName,
        "data-t": selectName,
        placeholder: PLACEHOLDER
    }));
});

export { CLPrescriptionSelect };
//# sourceMappingURL=CLPrescriptionSelect.js.map
